interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0A0A0A]' : 'bg-[#0A0A0A]/60 backdrop-blur-md'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-20 py-6 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img 
            src="https://public.readdy.ai/ai/img_res/48453f18-610d-43b5-9750-5afd8aebec95.png" 
            alt="Skarpe AS Logo" 
            className="h-10 w-10 object-contain"
          />
          <h1 className="text-lg font-light tracking-wide text-[#F5F5F5]">Skarpe AS</h1>
        </div>
        
        <ul className="flex items-center gap-12">
          {['Home', 'Products', 'Features', 'About', 'Contact'].map((item) => (
            <li key={item}>
              <button
                onClick={() => scrollToSection(item.toLowerCase())}
                className="text-sm font-light text-[#B0B0B0] hover:text-white transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                {item}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
